import session, { clearCache } from "../session";
import addHeaderToRequestOptions from "../../utils/add-header-to-request-options";

export const headerName = "Authorization";

const authorizationHeader = fetch => {
  return async (url, options = {}) => {
    const sessionBearer = await session();
    return fetch(
      url,
      addHeaderToRequestOptions(options, {
        [headerName]: `Bearer ${sessionBearer}`
      })
    ).then(async resp => {
      const { status } = resp;
      if (status === 401) {
        clearCache();
      }
      return resp;
    });
  };
};

export default authorizationHeader;
